import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { VolumesService } from 'src/app/course/services/volumes.service';
import _ from 'underscore';
import { AboutCourseModalComponent } from '../about-course-modal/about-course-modal.component';
import { DiscoverCourse } from '../../components/discover-courses/discover-course-model';
import PageHelper from '../helpers/page.helper';
import { StartAssessmentModalComponent } from '../start-assessment-modal/start-assessment-modal.component';
import { AuthContextService } from '../../services/auth-context.service';
import { AuthService } from '../../services/auth.service';
import { CourseHiddenStatus } from 'src/app/course/enums/course-hidden-status.enum';
import {MetaService} from 'src/app/services/meta.service';
import {TrainingService} from '../../training.service';

@Component({
  selector: 'app-discover',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.scss']
})
export class DiscoverComponent implements OnInit, OnDestroy {
  courses: any;
  courseGroups = [];
  user: any;
  videos: any[] = [];
  volume: any;
  pilotTrainingCourses: DiscoverCourse[] = [];
  pilotWorkshopsCourses: DiscoverCourse[] = [];
  getCurrentCourses: DiscoverCourse[] = [];
  avionicsCourses: DiscoverCourse[] = [];
  aircraftTransitionsCourses: DiscoverCourse[] = [];
  garminElearningCourses: DiscoverCourse[] = [];
  showGoTopArrow = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public volumesService: VolumesService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private authService: AuthService,
    private authContextService: AuthContextService,
    private metaService: MetaService,
    private trainingService: TrainingService
  ) { }

  ngOnInit(): void {
    this.metaService.addMetaTags('learn');

    this.courses = this.route.snapshot.data.courses;

    this.mapCourses();

    this.authContextService.onRenew().subscribe((user) => {
      this.user = user;
      this.mapCourses(); //remap with permissions
    });

    this.authService.renew();
    document.getElementsByTagName('body')[0].style.overflowX = 'hidden';
  }

  ngOnDestroy(): void {
    this.metaService.removeMetaTags();
  }

  private mapCourses() {
    const courseGroupsByTag = _.groupBy(this.courses.allCourseTypes, (course) => {
      return course.tagsList.length > 0 ? course.tagsList[0].text : 'Other';
    });

    const hiddenCourses = this.courses.hiddenCourses;

    const visibleCourse = (course) => {
      if (course != null)
        return (
          course.status === CourseHiddenStatus.PUBLISHED ||
          (this.trainingService.isTestMode())
        );
    };

    const hiddenCourse = (course) => {
      if (course != null)
        return !(
          course.purchased === false &&
          course.status === CourseHiddenStatus.HIDDEN
        ) || course.status === CourseHiddenStatus.REMOVED;
    };

    const mapCourse = (course) => {
      let previewLink = `course/${course.webAppId}/volumes`;

      if (
        course.inCoursePurchaseEnabled &&
        (course.webAppId === 'PRIVATE' ||
          course.webAppId === 'SPORT' ||
          course.webAppId === 'INSTRUMENT')
      ) {
        previewLink = `${previewLink}/VIDEO_TRAINING`;
      }

      return {
        title: course.longName,
        thumbnail_url: course.thumbnailUrl,
        difficulty: course.difficulty,
        price: course.price,
        previewLink,
        purchaseLink: course.webPurchaseUrl,
        isLocked: true,
        purchased: this.user ? !!this.user.coursePermissions[course.webAppId] : false,
        courseType: course.webAppId,
        requireRegistrationForPreview: course.requireRegistrationForPreview,
        buyLinkText: course.buyLinkText,
        status: course.status,
        inCoursePurchaseEnabled: course.inCoursePurchaseEnabled,
        shoppingCartImageUrl: course.shoppingCartImageUrl,
        deepLinkToMarketing: course.deepLinkToMarketing,
      };
    };

    const sortCourse = (a, b) => {
      return a.orderNum - b.orderNum;
    };

    this.pilotTrainingCourses = courseGroupsByTag['Pilot Training']
      .filter(visibleCourse)
      .sort(sortCourse)
      .map(mapCourse);

    this.pilotWorkshopsCourses = (courseGroupsByTag['Pilot Workshops'] || courseGroupsByTag['PilotWorkshops'])
      ? (courseGroupsByTag['Pilot Workshops'] || courseGroupsByTag['PilotWorkshops'])
        .filter(visibleCourse)
        .sort(sortCourse)
        .map(mapCourse)
      : [];

    this.getCurrentCourses = courseGroupsByTag['Get Current']
      .filter(visibleCourse)
      .sort(sortCourse)
      .map(mapCourse);

    this.avionicsCourses = courseGroupsByTag['Avionics']
      .filter(visibleCourse)
      .sort(sortCourse)
      .map(mapCourse);

    this.aircraftTransitionsCourses = courseGroupsByTag['Aircraft Transitions']
      .filter(visibleCourse)
      .sort(sortCourse)
      .map(mapCourse);

    this.garminElearningCourses = courseGroupsByTag['Garmin eLearning']
      .filter(visibleCourse)
      .sort(sortCourse)
      .map(mapCourse);

    this.pilotTrainingCourses.push(mapCourse(this.courses.allCourseTypes['FIRC_2025']));
  }

  openAboutThisCourseModal() {
    const initialState = {};
    this.bsModalRef = this.modalService.show(AboutCourseModalComponent, {
      initialState,
      class: 'modal-lg rounded-modal',
      backdrop: 'static'
    });
  }

  openStartAssessmentModal() {
    const initialState = {};
    this.bsModalRef = this.modalService.show(StartAssessmentModalComponent, {
      initialState,
      class: 'modal-lg rounded-modal',
      backdrop: 'static'
    });
  }

  goToTopOfPage() {
    PageHelper.topFunction();
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    if (window.pageYOffset === 0) {
      this.showGoTopArrow = false;
    } else {
      this.showGoTopArrow = true;
    }
  }
}
